/**
 * Formatação de valores de token (wei → humano).
 *
 * Cada token tem seu próprio número de casas decimais (`decimals`), então
 * NÃO dá pra assumir 18 fixo. Aqui convertemos o valor inteiro on-chain
 * (string de wei) pra uma representação legível:
 *
 *  - separa parte inteira e fracionária pelos `decimals` do token;
 *  - remove zeros à direita da fração (ex: 700.000,5000 → 700.000,5);
 *  - se a fração ficar vazia, mostra só o inteiro (ex: 700000 → 700.000);
 *  - aplica separador de milhar pt-BR na parte inteira.
 */
export function formatTokenAmount(raw: string | bigint | undefined, decimals = 18): string {
  if (raw === undefined || raw === null || raw === "") return "0";

  let value: bigint;
  try {
    value = typeof raw === "bigint" ? raw : BigInt(raw);
  } catch {
    return "0";
  }

  const negative = value < 0n;
  if (negative) value = -value;

  const base = 10n ** BigInt(decimals);
  const whole = value / base;
  const fraction = value % base;

  // Parte inteira com separador de milhar (pt-BR usa ponto).
  const wholeStr = whole.toLocaleString("pt-BR");

  let result: string;
  if (fraction === 0n || decimals === 0) {
    result = wholeStr;
  } else {
    // Fração com zeros à esquerda pra casar com `decimals`, depois corta
    // os zeros à direita que não agregam informação.
    let fractionStr = fraction.toString().padStart(decimals, "0").replace(/0+$/, "");
    result = fractionStr ? `${wholeStr},${fractionStr}` : wholeStr;
  }

  return negative ? `-${result}` : result;
}
